
(function(){
  const money = (cents, format) => {
    const value = (Number(cents || 0) / 100).toFixed(2);
    if (!format) return '$' + value;
    return format.replace(/\{\{\s*amount\s*\}\}/, value)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, String(Math.round(Number(cents||0)/100)));
  };

  function initVariantForm(scope){
    const form = scope.querySelector('form[data-product-form]');
    const variantsEl = scope.querySelector('[data-variants-json]');
    const idInput = scope.querySelector('input[name="id"]');
    const priceEl = scope.querySelector('[data-product-price]');
    const qtyInput = scope.querySelector('input[name="quantity"]');
    const submit = scope.querySelector('[data-add-to-cart]');
    if (!form || !variantsEl || !idInput) return;
    let variants = [];
    try { variants = JSON.parse(variantsEl.textContent); } catch(e) { return; }

    const optionGroups = Array.from(scope.querySelectorAll('[data-option-index]'));
    const selected = optionGroups.map(group => {
      const active = group.querySelector('[data-option-value].active') || group.querySelector('[data-option-value]');
      return active ? active.dataset.optionValue : null;
    });

    function syncVariant(){
      const variant = variants.find(v => {
        const opts = [v.option1, v.option2, v.option3].slice(0, optionGroups.length);
        return opts.every((opt, i) => String(opt) === String(selected[i]));
      }) || variants.find(v => v.available) || variants[0];
      if (!variant) return;
      idInput.value = variant.id;
      if (priceEl) {
        const q = Math.max(1, parseInt(qtyInput && qtyInput.value || '1', 10) || 1);
        priceEl.textContent = money(variant.price * q, window.LUXE_MONEY_FORMAT);
      }
      if (submit) {
        submit.disabled = !variant.available;
        submit.textContent = variant.available ? (submit.dataset.label || 'Add to Cart') : 'Sold Out';
      }
    }

    optionGroups.forEach((group, index) => {
      group.querySelectorAll('[data-option-value]').forEach(btn => {
        btn.addEventListener('click', () => {
          group.querySelectorAll('[data-option-value]').forEach(b => b.classList.remove('active'));
          btn.classList.add('active');
          selected[index] = btn.dataset.optionValue;
          const swatchLabel = group.parentElement.querySelector('[data-selected-label]');
          if (swatchLabel) swatchLabel.textContent = btn.dataset.optionValue;
          syncVariant();
        });
      });
    });

    scope.querySelectorAll('[data-qty-action]').forEach(btn => {
      btn.addEventListener('click', () => {
        if (!qtyInput) return;
        const current = Math.max(1, parseInt(qtyInput.value || '1',10));
        qtyInput.value = btn.dataset.qtyAction === 'increase' ? current + 1 : Math.max(1, current - 1);
        syncVariant();
      });
    });
    if (qtyInput) qtyInput.addEventListener('change', syncVariant);

    form.addEventListener('submit', async (e) => {
      if (!window.fetch) return;
      e.preventDefault();
      const msg = scope.querySelector('[data-form-message]');
      if (msg) { msg.textContent='Adding…'; msg.className='product-form-message'; }
      try {
        const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
          method:'POST', headers:{'Accept':'application/json'}, body:new FormData(form)
        });
        if (!response.ok) throw new Error((await response.json()).description || 'Could not add item.');
        const cartResponse = await fetch(window.Shopify.routes.root + 'cart.js', {headers:{'Accept':'application/json'}});
        const cart = await cartResponse.json();
        document.querySelectorAll('[data-cart-count]').forEach(el => el.textContent = cart.item_count);
        if (msg) { msg.textContent='Added to your cart ✓'; msg.className='product-form-message success'; }
      } catch(err) {
        if (msg) { msg.textContent=err.message || 'Could not add item.'; msg.className='product-form-message error'; }
      }
    });
    syncVariant();
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-product-scope]').forEach(initVariantForm);
    const toggle = document.querySelector('[data-mobile-toggle]');
    const menu = document.querySelector('[data-mobile-menu]');
    if (toggle && menu) toggle.addEventListener('click', () => menu.classList.toggle('active'));
  });
})();
